import React from "react";
import "./Vision_Mission_Value.css";
import { VisionMissions } from "../../../utils/apis/aboutus/Aboutus.js";
import { useEffect, useState } from "react";
import { IDS } from "../../../utils/common";

const Vision_Mission_Value = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [visionmission, setVisionMission] = useState([]);

  const getVisionMission = async () => {
    const res = await VisionMissions();

    if (res?.success) {
      setVisionMission(res?.data || []);
    }
  };

  useEffect(() => {
    getVisionMission();
  }, []);

  const vision = visionmission.find((item) =>
    item.name?.toLowerCase().includes("vision"),
  );

  const mission = visionmission.find((item) =>
    item.name?.toLowerCase().includes("mission"),
  );

  const value = visionmission.find((item) =>
    item.name?.toLowerCase().includes("value"),
  );

  return (
    <section className="vision_mission_section">
      <div className="container">
        <p className="head_text">Why choose us for your event management</p>

        <p className="text">
          We bring together innovation, precision, and complete event management
          to create unforgettable experiences tailored to your vision.
        </p>

        <div className="columns_wrapper">
          {/* Vision */}
          <div className="column column1">
            <div className="content_block vision">
              <h3>{vision?.name}</h3>
              <p>{htmlToReactParser.parse(vision?.description || "")}</p>
            </div>

            <div className="content_image">
              <img src={IDS?.IMG_URL + vision?.image} alt="Vision" />
            </div>
          </div>

          {/* Mission */}
          <div className="column column2">
            <div className="content_image top_image">
              <img src={IDS?.IMG_URL + mission?.image} alt="Mission" />
            </div>

            <div className="content_block mission">
              <h3>{mission?.name}</h3>
              <p>{htmlToReactParser.parse(mission?.description || "")}</p>
            </div>
          </div>

          {/* Value */}
          <div className="column column3">
            <div className="content_block value">
              <h3>{value?.name}</h3>
              <p>{htmlToReactParser.parse(value?.description || "")}</p>
            </div>

            <div className="content_image">
              <img
                src={IDS?.IMG_URL + value?.image}
                alt="Value"
                className="image_"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision_Mission_Value;
